import { Command } from '../command-queue/command.interface';
import { TriggerManager } from '../trigger-manager/trigger-manager';
import cloneDeep from 'lodash.clonedeep';

export class TriggerCommand implements Command {
  triggerArguments: any[];
  constructor(private name: string, private args: any[]) {
    this.triggerArguments = cloneDeep(args);
  };

  getCtorArgs(): any[] {
    return [this.name, ...this.args];
  }

  execute(): Promise<unknown> {
    return TriggerManager.executeTrigger(this.name, this.triggerArguments);
  }
};
